<template>

  <section class="bulk-issue-surface">

    <div class="bulk-issue-surface__toolbar">

      <div class="bulk-issue-surface__meta">
         <strong>{{ selectedCount }}</strong
        > / {{ items.length }} hóa đơn sẽ đi vào lệnh phát hành
      </div>

      <div class="bulk-issue-surface__actions">
         <b-button
          size="sm"
          variant="link"
          class="bulk-issue-surface__link"
          @click="$emit('select-all')"
          >Chọn tất cả</b-button
        > <b-button
          size="sm"
          variant="link"
          class="bulk-issue-surface__link"
          @click="$emit('deselect-all')"
          >Bỏ chọn tất cả</b-button
        >
      </div>

    </div>
     <b-table
      :items="items"
      :fields="fields"
      small
      bordered
      responsive
      show-empty
      empty-text="Không có hóa đơn đủ điều kiện"
      class="bulk-issue-table"
      > <template #cell(selected)="{ item }"
        > <b-form-checkbox
          :checked="selectedIds.includes(item.salesInvoiceId)"
          @change="$emit('toggle', item)"
        ></b-form-checkbox
        > </template
      > <template #cell(invoiceNo)="{ item }"
        >
        <div class="bulk-issue-table__primary-cell">
           <strong>{{ item.invoiceNo }}</strong
          >
          <!-- <small>{{ item.salesInvoiceId }}</small> -->
        </div>
         </template
      > <template #cell(buyerName)="{ item }"
        > <span :class="{ 'bulk-issue-table__fallback': !item.buyerName }"
          > {{ item.buyerName || 'Khách lẻ' }} </span
        > </template
      > <template #cell(totalAmount)="{ item }"
        >
        <div class="text-right bulk-issue-table__amount">
          {{ formatCurrency(item.totalAmount) }}
        </div>
         </template
      > </b-table
    >
  </section>

</template>

<script>
  export default {
    name: 'BulkIssueEligibleTable',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      selectedIds: {
        type: Array,
        default: () => [],
      },
      formatCurrency: {
        type: Function,
        required: true,
      },
    },
    computed: {
      selectedCount() {
        return this.selectedIds.length
      },
      fields() {
        return [
          { key: 'selected', label: '', thStyle: { width: '40px' }, tdClass: 'text-center' },
          { key: 'invoiceNo', label: 'Số HĐ' },
          { key: 'buyerName', label: 'Khách hàng' },
          { key: 'totalAmount', label: 'Tổng tiền', thClass: 'text-right', tdClass: 'text-right' },
        ]
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-surface {
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
  }

  .bulk-issue-surface__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem 0.65rem;
    border-bottom: 1px solid #edf1f6;
  }

  .bulk-issue-surface__meta {
    color: #445166;
    font-size: 0.84rem;
  }

  .bulk-issue-surface__actions {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .bulk-issue-surface__link {
    padding: 0;
    color: #187de4 !important;
    font-weight: 600;
  }

  .bulk-issue-table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table thead th {
    background: #f7f9fc;
    color: #445166;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .bulk-issue-table__primary-cell {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-issue-table__primary-cell strong {
    color: #1f2a3d;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .bulk-issue-table__primary-cell small {
    color: #7c8798;
    font-size: 0.72rem;
    word-break: break-all;
  }

  .bulk-issue-table__fallback {
    color: #8a94a5;
    font-style: italic;
  }

  .bulk-issue-table__amount {
    font-variant-numeric: tabular-nums;
    font-weight: 600;
  }

  @media (max-width: 767.98px) {
    .bulk-issue-surface__toolbar {
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>
